export default __webpack_public_path__ + "static/media/team-5.bba518ed.jpg";